import React from 'react';
import ReactDOM from 'react-dom';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import App from './App';

declare global {
  interface Window {
    env: any;
  }
}

const host = window.location.host

const takeHost = (position: number, urls: string) => {
  const result = urls.split(",")[position];
  return result === undefined ? '' : result;
}

let SECRET_KEY = 'd1oUOlGO4vjOXEmDBsDEcg=='
let GCAPTCHA_APIKEY   = '6LeU8owqAAAAAC2zGxWZFTMc-cYkekbFYINqyQVX';
let ONBOARDING_APIKEY = "Ff388jFGWbP1pbyu7BrFC54rMaj7dAgF";
let BFF_ONBOARDING_URL   = 'http://192.168.74.172:8981/api';
let API_BACKEND_URL   = 'http://localhost:8080';
const URL_PRISMA_HOME = 'https://semweb.prismamediosdepago.com/adhesioncomercio/#/inicio';
let URL_ONBOARDING    = 'http://localhost:3000/onboarding';
let URL_BACKOFFICE    = 'https://dev.decidir.com/portal/';
let URL_SAC    = 'https://dev.decidir.com/sac/LoginServlet';
let URL_PUBLIC_SITE   = 'http://localhost:3002/publicsite';
let URL_MS_TRAVEL_ESTABLISHMENT = 'http://localhost:8080';
const LEGAL_TERMS_URL = 'https://www.payway.com.ar/legales';

if(host.toLowerCase().includes("payway")) {

  SECRET_KEY = takeHost(1, window.env.SECRET_KEY);
  GCAPTCHA_APIKEY = takeHost(1, window.env.GCAPTCHA_APIKEY);
  BFF_ONBOARDING_URL = takeHost(1, window.env.BFF_ONBOARDING_URL);
  API_BACKEND_URL = takeHost(1, window.env.API_BACKEND_URL);
  URL_ONBOARDING  = takeHost(1, window.env.URL_ONBOARDING);
  URL_BACKOFFICE  = takeHost(1, window.env.URL_BACKOFFICE);
  URL_SAC  = takeHost(1, window.env.URL_SAC);
  URL_PUBLIC_SITE = takeHost(1, window.env.URL_PUBLIC_SITE);
  URL_MS_TRAVEL_ESTABLISHMENT = takeHost(1, window.env.URL_MS_TRAVEL_ESTABLISHMENT);
  ONBOARDING_APIKEY = takeHost(1, window.env.ONBOARDING_APIKEY);

} else if(host.toLowerCase().includes("decidir")) {

  SECRET_KEY = takeHost(0, window.env.SECRET_KEY);
  GCAPTCHA_APIKEY = takeHost(0, window.env.GCAPTCHA_APIKEY);
  BFF_ONBOARDING_URL = takeHost(0, window.env.BFF_ONBOARDING_URL);
  API_BACKEND_URL = takeHost(0, window.env.API_BACKEND_URL);
  URL_ONBOARDING  = takeHost(0, window.env.URL_ONBOARDING);
  URL_BACKOFFICE  = takeHost(0, window.env.URL_BACKOFFICE);
  URL_SAC  = takeHost(0, window.env.URL_SAC);
  URL_PUBLIC_SITE = takeHost(0, window.env.URL_PUBLIC_SITE);
  URL_MS_TRAVEL_ESTABLISHMENT = takeHost(0, window.env.URL_MS_TRAVEL_ESTABLISHMENT);
  ONBOARDING_APIKEY = takeHost(0, window.env.ONBOARDING_APIKEY);

}

export {
  BFF_ONBOARDING_URL,
   API_BACKEND_URL,
    URL_PRISMA_HOME,
    URL_ONBOARDING,
    URL_BACKOFFICE,
    URL_SAC,
    URL_PUBLIC_SITE,
    URL_MS_TRAVEL_ESTABLISHMENT,
    LEGAL_TERMS_URL,
    ONBOARDING_APIKEY,
   SECRET_KEY
}

ReactDOM.render(
  <React.StrictMode>
    <GoogleReCaptchaProvider
      reCaptchaKey={ GCAPTCHA_APIKEY }
      language="es-419"
      useRecaptchaNet={ false }
      scriptProps={{
        async: false, // optional, default to false,
        defer: false ,// optional, default to false
        appendTo: "head", // optional, default to "head", can be "head" or "body",
        nonce: undefined // optional, default undefined
      }}
    >
      <App />
    </GoogleReCaptchaProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
